function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.2.76l2.48 5.86 6.34.55a.5.5 0 01.29.87l-4.81 4.17 1.44 6.2a.5.5 0 01-.75.55l-5.45-3.3-5.45 3.3a.5.5 0 01-.75-.55L5 12.21.17 8.04a.5.5 0 01.29-.87l6.34-.55L9.28.76a.5.5 0 01.92 0z"
});
function SvgStar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19.48 19.48",
    ref: svgRef
  }, props), _ref);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default ForwardRef;